import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HomeSeo from '@/components/base/HomeSeo';
import HeroSection from './components/HeroSection';
import FeatureGrid from './components/FeatureGrid';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import ArticleGrid from './components/ArticleGrid';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <main className="min-h-screen">
      <Navbar />
      <HeroSection />
      <FeatureGrid />
      <CategoryGrid />
      <AboutSection />
      <ArticleGrid />
      <TestimonialSection />
      <CTASection />
      <FAQSection />
      <HomeSeo />
      <Footer />
    </main>
  );
}